<template>
  <div
    v-if="banner"
    class="global-subscription-alert"
    :class="banner.level === 'critical' ? 'is-critical' : 'is-warning'"
  >
    <div class="global-subscription-alert__content">
      <i class="fa" :class="banner.level === 'critical' ? 'fa-exclamation-circle' : 'fa-clock-o'"></i>
      <div>
        <h6>{{ banner.title }}</h6>
        <p>{{ banner.message }}</p>
      </div>
    </div>

    <button v-if="showRenewCta && !efirmaIncident" type="button" class="btn btn-primary btn-sm" @click="goToSubscription">
      Renovar ahora
    </button>
  </div>
</template>

<script>
import accountService from '@/services/account';
import dashboardService from '@/services/dashboard';

export default {
  name: 'GlobalSubscriptionAlert',
  data() {
    return {
      status: null,
      loading: false,
      efirmaIncident: null,
    };
  },
  computed: {
    isInsideSubscriptionSettings() {
      return this.$route?.name === 'settings' && String(this.$route?.query?.section || '') === 'subscription';
    },
    showRenewCta() {
      return !this.isInsideSubscriptionSettings;
    },
    banner() {
      const status = this.status;
      if (!status && !this.efirmaIncident) return null;

      if (this.efirmaIncident) {
        return {
          level: 'critical',
          title: this.efirmaIncident?.warning_title || 'Se detectaron fallas continuas en descargas CFDI',
          message: this.efirmaIncident?.warning_message || 'Durante 7 días consecutivos han fallado las descargas CFDI. Revisa y actualiza la e.firma para reactivar las descargas.',
        };
      }

      if (status.warning) {
        return status.warning;
      }

      if (status.is_expired) {
        return {
          level: 'critical',
          title: 'Tu suscripción está vencida',
          message: 'No podrás registrar nuevas solicitudes de descarga ni RFCs hasta renovar tu paquete.',
        };
      }

      const days = Number(status.days_remaining ?? 9999);
      if (status.has_active_period && days <= 10) {
        return {
          level: 'warning',
          title: 'Tu suscripción está por vencer',
          message: `Vence en ${days} día(s). Renueva hoy para mantener tus descargas y automatizaciones activas.`,
        };
      }

      return null;
    },
  },
  mounted() {
    this.loadStatus();
  },
  methods: {
    async loadStatus() {
      if (this.loading) {
        return;
      }

      this.loading = true;
      try {
        const response = await accountService.getSubscription();
        this.status = response?.data?.status || null;

        const rfc = String(localStorage.getItem('rfc') || '').trim().toUpperCase();
        if (rfc) {
          const history = await dashboardService.getDownloadCenterHistory(rfc, 1, 1, { skipLoading: true });
          this.efirmaIncident = history?.efirma_incident || null;
        } else {
          this.efirmaIncident = null;
        }
      } catch (error) {
        this.status = null;
        this.efirmaIncident = null;
      } finally {
        this.loading = false;
      }
    },
    goToSubscription() {
      this.$router.push({
        name: 'settings',
        query: {
          section: 'subscription',
        },
      });
    },
  },
};
</script>
